import script from "./DocumentacaoTelaAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentacaoTelaAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./DocumentacaoTelaAdministrar.vue?vue&type=style&index=0&id=6260c1ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6260c1ca"]])

export default __exports__